import { Box, Button, TextInput, Layer, Header, Text,  Spinner, Select, CheckBox, ResponsiveContext, Image} from "grommet";
import { useState, useEffect, useContext, useRef } from "react";
import { Trash, View, Search } from "grommet-icons";
import { useFetch } from "use-http";
import { useNavigate } from "react-router-dom";
import { getDBURL, maxRowsOnField, maxVinesOnRow, generateSyncId, correctTimeZone, isValidYearString, usePopupFocus } from "../Utils/Utils";
import useTrapFocus from "../Utils/useTrapFocus";
import WarningPopupWindow from "./WarningPopupWindow";
import StationsField from "./StationsField";
import ParentsListWindow from "./ParentsListWindow";
import { useDataContext } from '../Contexts/DataContext';
import { UserContext } from "../../App";
import { useErrorLogger } from './Logger';
import CultivarDetails from '../Cultivars/CultivarDetails';


/*
The StationPopup component is designed to facilitate the creation of new stations within a selected field. 
The user-friendly interface allows the user to create stations either from seedlings or by referencing existing stations in the field. 
The component provides an interactive visualization of the field layout, 
with real-time validation to ensure that the new station adheres to the field's parameters.
**/

const StationPopup = (props) => {
     console.log('In StationPopup props obj:', props);
    // console.log("In stationPopup plantInfo >> ", props.plantInfo);  
    const currentUser = useContext(UserContext);
    const { fieldList } = useDataContext();
    const { rootstockList } = useDataContext();

    const navigate = useNavigate();
    const { get, post, loading, error } = useFetch(getDBURL());
    const { DBlogError } = useErrorLogger();

    const [rowsCollection, setRowsCollection] = useState([]);   // all stations displayed on the screen, including those not yet added, only supposed ones
    const [occupiedStations, setOccupiedStations] = useState([]);   // only stations that are already on the field (loaded from the database)
    const [occupiedLocations, setOccupiedLocations] = useState([]); // scions that are already on the field (loaded from the database)
   

    const [checkAll, setCheckAll] = useState(true);
    
    const [year, setYear] = useState(new Date().getFullYear());  
    const [rootstock, setRootstock] = useState({Id: '00000000-0000-0000-0000-000000000000', Name: ""});
    const [fieldName, setFieldName] = useState("");
    const [stationName, setStationName] = useState("");
    const [rowNumForView, setRowNumForView] = useState("");
    
    // console.log("In stationPopup selectedField >> ", props.selectedField); 
    // const [selectedField, setSelectedField] = useState({Id: '00000000-0000-0000-0000-000000000000', RowFrom: 0, RowTo: 0, FieldName: "", FieldType: 0, VinesOnRow: 0, Description: ""});
    // const [selectedField, setSelectedField] = useState(props.selectedField != undefined ? props.selectedField : {Id: '00000000-0000-0000-0000-000000000000', RowFrom: 0, RowTo: 0, FieldName: "", FieldType: 0, VinesOnRow: 0, Description: ""});
    const [field, setField] = useState(props.selectedField != undefined ? props.selectedField : {Id: '00000000-0000-0000-0000-000000000000', RowFrom: 0, RowTo: 0, FieldName: "", FieldType: 0, VinesOnRow: 0, Description: ""});


    const [startRowNum, setStartRowNum] = useState(0); // number to start new row 
    const [startRowStr, setStartRowStr] = useState(''); // string for changing the start row 

    const [startColNum, setStartColNum] = useState(0); // number to start new column 
    const [totalNumberOfVines, setTotalNumberOfVines] = useState(10); // number of scions on station

    const [showWarning, setShowWarning] = useState(false);
    const [warningMessage, setWarningMessage] = useState(''); 

    const [openParentsListWindow, setOpenParentsListWindow] = useState(false);
    const [selectedCultivar, setSelectedCultivar] = useState({Id: '00000000-0000-0000-0000-000000000000', Name: "", DisplayName: "", ObjectType: 0, CultivarId: null});   // cultivar name for new station

    const [newCultivar, setNewCultivar] = useState(null); // State to store new cultivar
    const [showCultivarDetails, setShowCultivarDetails]  = useState(false); // show popup with CultivarDetails 
    
    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open   

    // Manage focus when opening modal windows
    usePopupFocus(showWarning, "warning-msg");
    usePopupFocus(openParentsListWindow, "parents");
    usePopupFocus(showCultivarDetails, "parents");
    

    const changeSelectedCultivar = (cultivar) =>
    {
        // console.log('cultivar >> ', cultivar);
        // console.log('selectedCultivar >> ', selectedCultivar);
        setSelectedCultivar({Id: cultivar.cId, Name: cultivar.cName, DisplayName: cultivar.cDisplayName, ObjectType: cultivar.cObjectType, CultivarId: cultivar.cCultivarId});
        setStationName(cultivar.cName);
        setRootstock({Id: cultivar.cRootstockId === null ? '00000000-0000-0000-0000-000000000000' : cultivar.cRootstockId  , Name: cultivar.cRootstock});
    }

    // This function uses the Array.prototype.reduce() method to iterate through the occupiedStations array 
    // and return the maximum StationNum of the elements where RowNum is equal to the input rowNum parameter. 
    const getMaxOccupiedStationNum = (arr, fieldId) => {
        // console.log('arr >> ', arr);
        return arr.reduce((maxNum, { FieldNum, StationNum }) => 
            FieldNum === fieldId && StationNum > maxNum ? StationNum : maxNum, 0)+1;
    };  

    const getDefaultNewStationNum = (arr) => {
        // console.log('arr >> ', arr);
        if (arr !== null && arr !== undefined && arr.length > 0) {
            return arr.reduce((maxNum, { Num }) => 
                Num > maxNum ? Num : maxNum, 0)+1;
        }
        else 
            return 1;
    };  

    // const [newStationNum, setNewStationNum] = useState(0); // number for new station 
    const [newStationNum, setNewStationNum] = useState(generateSyncId()); // id for new station 

    const getDefaultNewStationName = () => {
        // console.log('plantInfo >> ', props.plantInfo);
        if (props.plantInfo !== null && props.plantInfo !== undefined) {
            return props.plantInfo.Year + '-' + props.plantInfo.Row + '-' + props.plantInfo.Column;
        }
        else if (props.plantInfo === undefined && selectedCultivar !== undefined) {
            return selectedCultivar.Name;
        }
        else
            return '';
    };  


    // size of screen: small - mobile, medium ipad, large - computer
    const size = useContext(ResponsiveContext);

    const updateRowsCollectionState = (rowNum, stationNum, propName, value) => {
        // console.log('rowNum >> ', rowNum); 
        // console.log('stationNum >> ', stationNum); 
        // console.log('propName >> ', propName); 
        // console.log('value >> ', value); 
        const newState = rowsCollection.map(obj => {
            // 👇️ if row and station equals to requared, update  property
            if (obj.RowNum === rowNum && obj.StationNum === stationNum) { 
                // console.log('obj >> ', obj);           
                return {...obj, [propName]: value};
            }
            
            // 👇️ otherwise return object as is
            return obj;
        });
        // console.log('newState >> ', newState);
        setRowsCollection(newState);
    };

    
    // if arr (rowsCollection or occupiedStations) length > 0 and station found returns station object
    // otherwise returns undefined   
    const getStationByRowStationNum = (arr, row, station) => {
        // console.log('In getStationByRowStationNum arr >> ', arr);
        // console.log('In getStationByRowStationNum row >> ', row);
        // console.log('In getStationByRowStationNum station >> ', station);
        if (arr !== null && arr !== undefined && arr.length > 0) {
            return arr.find((element) => {
                return (element.RowNum === row && element.StationNum === station);
            });
        }
    }; 

    const getPrevStation = (arr, row, station) => {
        if (arr !== null && arr !== undefined && arr.length > 0) {
            let currentIndex = arr.findIndex(element => element.RowNum === row && element.StationNum === station);
            return arr[currentIndex - 1];
        }
    };
    
    const getNextStation = (arr, row, station) => {
        if (arr !== null && arr !== undefined && arr.length > 0) {
            let currentIndex = arr.findIndex(element => element.RowNum === row && element.StationNum === station);
            return arr[currentIndex + 1];
        }
    };

    // if arr (ocLocations) length > 0 and scion found returns scion object
    // otherwise returns undefined   
    const getScionByRowCol = (arr, row, col) => {
        if (arr !== null && arr !== undefined && arr.length > 0) {
            return arr.find((element) => {
                return (element.ScionRow === row && element.ScionColumn === col);
            });
        }
    };     

    // The function is used to check whether the station is in one row,
    // Or maybe the station starts at the end of one row and continues on the second
    // for example (station: 5 row 201 vines: 116-120
    //              station: 5 row 202 vines: 1-5)

    // The function iterates over the array of stations (upper part of screen).
    // If an object with the matching StationNum and RowNum is found, 
    // then checks adjacent objects in the array 
    // If found neighbor with same StationNum and other RowNum. 
    // then count is increased by 1 and returned as the result.
    function getNumberRowsOnStation(array, stationNum, rowNum) {
        let count = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i].StationNum === stationNum && array[i].RowNum === rowNum) {
                count++;
                
                // check next object in array
                let n = i + 1; 
                if (n < array.length && array[n].StationNum === stationNum && array[n].RowNum !== rowNum) {
                    return ++count;
                }
                // check prev object in array
                let p = i - 1; 
                if (p >= 0 && array[p].StationNum === stationNum && array[p].RowNum !== rowNum) {
                    return ++count;
                }

            }
        }
        return count;
    }

    
    
    const onChangeStartRow = (rowNum) => {
        // console.log('In onChangeStartRow f-n !!');
        // console.log('In change "row for new station" rowNum >> ',rowNum)
        // console.log('In change "row for new station" field.RowFrom >> ', field.RowFrom)
        
        setStartRowStr(rowNum);

        if (Number(rowNum) > (field.RowTo))
        {
            setWarningMessage('Row number can\'t be bigger than ' + Number(field.RowTo));
            setShowWarning(true);
            setStartRowNum(field.RowTo);
            return;
        }

        if (Number(rowNum) < (field.RowFrom))
        {
            // setWarningMessage('Row number can\'t be smaller than ' + Number(selectedField.RowFrom+1));
            // setShowWarning(true);
            // setStartRowNum(selectedField.RowFrom+1);
            return;
        }
        setStartRowNum(Number(rowNum));
        setRowNumForView(Number(rowNum));
    }

    const onChangeStartCol = (colNum) => {
        // console.log('In onChangeStartCol f-n !!');
        // console.log('In change "start column for new station" colNum >> ',colNum)

        setStartColNum(Number(colNum));

        if(colNum === '' || colNum === 0 )
            return;

        if (Number(colNum) < 1)
        {
            setWarningMessage('Column number can\'t be smaller than 1');
            setShowWarning(true)
            setStartColNum(1);
            return;
        }

        if (Number(colNum) > field.VinesOnRow)
        {
            setWarningMessage('Column number can\'t be bigger than ' + field.VinesOnRow);
            setShowWarning(true)
            setStartColNum(field.VinesOnRow);
            return;
        }
    }

    const onChangeTotalNumberOfVines = (numberOfVines) => {        
        if(numberOfVines === '' || numberOfVines === 0 )
            return;

        if (Number(numberOfVines) < 1)
        {
            setWarningMessage('Column number can\'t be smaller than 1');
            setShowWarning(true)
            setTotalNumberOfVines(1);
            return;
        }
        setTotalNumberOfVines(Number(numberOfVines));        
    }

    const onChangeStationFromCol = (num, row, station) => {
        // console.log('In change "from column" on station !!');
        // console.log('In change "from column" num >> ',num)
        // console.log('In change "from column" row >> ',row)
        // console.log('In change "from column" station >> ',station)

        let temp = [...rowsCollection];
        let selectedStation = getStationByRowStationNum(temp, Number(row), station);
        // console.log('selectedStation >> ',selectedStation);
        // let prevStation = getPrevStation(temp, Number(row), Number(station));
        let prevStation = getPrevStation(temp, Number(row), station);
        
        // console.log('prevStation >> ',prevStation);

        if(num === '')
            return;       
        
        
        if (Number(num) < 1)
        {
            // if(prevStation === undefined)            
            //     updateRowsCollectionState(row, station, 'FromCol', 1);
            
            const numRowsOnStation = getNumberRowsOnStation(temp, selectedStation.StationNum, selectedStation.RowNum);
            // console.log('numRowsOnStation >> ', numRowsOnStation);
            if (numRowsOnStation === 2)
                return;
              
            temp = addScionsToPrevRow(selectedStation); 
            setRowsCollection(temp);  
            return;     
        }

        let changeOn = Number(num); 
        // check ToCol on previous station -> if prev station not exist then 1,
        // otherwise previous Station.ToCol+1
        if (Number(num) > selectedStation.ToCol) 
            changeOn = selectedStation.ToCol;
        else if  (prevStation !== undefined && (prevStation.RowNum === selectedStation.RowNum && Number(num) <= prevStation.ToCol))
            changeOn = prevStation.ToCol+1;
        else
            changeOn = (Number(num) > 1) ? Number(num) : 1;       
 
        selectedStation.FromCol = changeOn;

        // check that total number of planned locations are not bigger than totalNumberOfVines (10)
        let nextStation = getNextStation(temp, Number(row), station);
        // console.log('nextStation >> ',nextStation);
        const scionsOnRow = (nextStation !== undefined && nextStation.StationNum === selectedStation.StationNum && nextStation.RowNum !== selectedStation.RowNum) ? field.VinesOnRow : 0;
        let st = scionsOnRow > 0 ? nextStation : selectedStation;

        // console.log('changeOn + totalNumberOfVines - (totalNumberOfVines - 1)) >> ',changeOn + (totalNumberOfVines - 1) - scionsOnRow);
        if (st.ToCol > (changeOn + (totalNumberOfVines - 1) - scionsOnRow))
            st.ToCol = changeOn + (totalNumberOfVines - 1) - scionsOnRow;

        setRowsCollection(temp);
        // reRender();
    }   

    const onChangeStationToCol = (num, row, station) => {
        // console.log('In change "to column" on station !!');
        // console.log('In change "to column" num >> ',num)
        // console.log('In change "to column" row >> ',row)
        // console.log('In change "to column" station >> ',station)

        let temp = [...rowsCollection];
        let selectedStation = getStationByRowStationNum(temp, Number(row), station)
        // console.log('selectedStation >> ',selectedStation);

        if(num === '' || (Number(num) < 1))
        {
            updateRowsCollectionState(row, station, 'ToCol', selectedStation.FromCol);
            return;
        }

        if(num > field.VinesOnRow)
        {
            if (row === field.RowTo) {
                updateRowsCollectionState(row, station, 'ToCol', field.VinesOnRow);
                return;
            }
            else {
                const numRowsOnStation = getNumberRowsOnStation(temp, selectedStation.StationNum, selectedStation.RowNum);
                // console.log('numRowsOnStation >> ', numRowsOnStation);
                if (numRowsOnStation === 2)
                    return;
                temp = addScionsToNextRow(selectedStation);        
            }
        }

        let nextStation = getNextOccupiedStation(selectedStation.RowNum, selectedStation.ToCol);        
        // console.log('nextStation >> ',nextStation);

        let changeOn = Number(num);

        // check: if num bigger than fromCol at the current station(it is ok), 
        // then it also must be  smaller than FromCol of the next station (next Station.FromCol-1)
        // if it is last station, then add total scions number ( to field Station.ToCol) not more than totalNumberOfVines
        if (changeOn < selectedStation.FromCol)
            changeOn = selectedStation.FromCol;
        else if  (nextStation !== undefined && (nextStation.RowNum === selectedStation.RowNum && Number(num) >= nextStation.FromCol))
            changeOn = nextStation.FromCol-1;
        else
            changeOn = (Number(num) - selectedStation.FromCol) <= totalNumberOfVines ? Number(num) : ( selectedStation.FromCol + totalNumberOfVines -1);       

        selectedStation.ToCol = changeOn > field.VinesOnRow ? field.VinesOnRow : changeOn;

        // ensure that the total number of locations is not greater than totalNumberOfVines (10)
        // if yes, then move all locations to the right
        
        let prevStation = getPrevStation(temp, Number(row), station);

        // check how many rows planned station includes, if two rows at station then change first row (FromCol) otherwise FromCol on this one.
        const oneRowStation =  (prevStation !== undefined && prevStation.StationNum === selectedStation.StationNum && prevStation.RowNum !== selectedStation.RowNum) ? false : true;
        const scionsOnRow = oneRowStation ? 0 : field.VinesOnRow;
        
        let st = scionsOnRow > 0 ? prevStation : selectedStation;

        if (st.FromCol < (changeOn + scionsOnRow - (totalNumberOfVines - 1)))
            st.FromCol = changeOn + scionsOnRow - (totalNumberOfVines - 1);

        if (!oneRowStation && ((selectedStation.ToCol - selectedStation.FromCol) >= (totalNumberOfVines-1)))
            temp = removePrevRow(prevStation);

        setRowsCollection(temp);
    };

    const createScion = (id, row, col, stationId, occupied, uprooted, freeLocation, isSeedling) => {
        let scion;
        if (typeof id === 'object') 
            scion = {
                Id: id.Id,
                Row: id.Row,
                Column: id.Column,
                StationId: id.StationId,
 //               StatusID: id.StatusID,       
 //               Checked: id.Checked, 
                Occupied:  id.Occupied,
                Uprooted: id.Uprooted,
                FreeLocation: id.FreeLocation,
                IsSeedling: id.IsSeedling,
            };
        else 
            scion = 
            {  
                Id: id,
                Row: row,
                Column: col,
                StationId: stationId,
 //               StatusID: 0,        
//                Checked: checked, 
                Occupied:  occupied,
                Uprooted: uprooted,
                FreeLocation: freeLocation,
                IsSeedling: isSeedling,               
            };
        return scion;
    };

    // plantInfos - array of scions on stations
    const [plantInfos, setPlantInfos] = useState([]); 

    
    // load scions for selected field
    async function loadExistedStationsFromDB(fieldId) {
        // console.log('In loadExistedStationsFromDB: fieldId >> ', fieldId);
        try {
            // added parameter Date.now() to prevent hash
            const response = await get("/loadScionsByField/field_id=" + fieldId + "/dt=" + Date.now());
            // console.log('In loadExistedStationsFromDB res >>  ', response);

            // Check if the response is successful
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }
    
            const res = response.result;

            if (res !== undefined && res[0] !== undefined && res[0].length > 0)  {
                // console.log("loaded scion list from DB res[]:  ", res[0]);
                let prevStation = '00000000-0000-0000-0000-000000000000';
                let values = [];
                let station = {};
                let ocLocations = [];
                res[0].forEach(item => { 
                    ocLocations.push(item);
                    let stationNum = item.StationNum;
                    let start = prevStation !== stationNum ? true : station.RowNum !== undefined && station.RowNum !== item.ScionRow ? true : false;
                    if (start) {
                        station = {
                            FieldNum: item.FieldId,
                            RowNum: item.ScionRow,
                            StationNum: stationNum,
                            StationName: item.StationName,
                            FromCol: item.ScionColumn,
                            ToCol: item.ScionColumn,
                            Selected: false,
                            Occupied: true,
                            // Uprooted: item.IsUprooted,
                            // FreeLocation: item.FreeLocation, 
                        };
                        values = values.concat(station);
                        prevStation = stationNum;
                        start = false;
                    }
                    else {
                        station.ToCol = item.ScionColumn;                          
                    }    
                })
                // console.log("occupiedStations from DB >> ", values); 
                setOccupiedStations(values);  
                //setNewStationNum(getMaxOccupiedStationNum(values, fieldId));                    
                // console.log("ocLocations from DB >> ", ocLocations);
                setOccupiedLocations(ocLocations); 
            }
        }
        catch (error) {
            console.error('🔴 Error in loadExistedStationsFromDB error: ' + error.message);

            // Construct error object
            const errorDetails = {
                error: error,
                parameters: { fieldId: fieldId },
                userName: currentUser.email,
                moduleName: 'StationPopup',
                functionName: 'loadExistedStationsFromDB',
                description: `Error in loadExistedStationsFromDB for field ${fieldId}`
            };
            await DBlogError(errorDetails);
        }
    };


    const isStationExist = (stationNum) => {
        let found = false;
        if (props.parentsList.length > 0) {
            // get last station from rowsCollection (the new station for adding)
            found = props.parentsList.find((station) => station.Num === stationNum);
        }
        return found;
    };

    useEffect(() => {
        if (props.plantInfo != undefined) {
        // setNewStationNum( getDefaultNewStationNum(props.parentsList));        
            setStationName(getDefaultNewStationName());
        }
    }, []);     

    // console.log('rootstockList >>> ', rootstockList);
 
        
    useEffect(() => {
        // console.log(" In useEff !!!");
        if (field.Id === '00000000-0000-0000-0000-000000000000') {
            // setFieldName('No field selected ');
            return;
        }

        const startRow = startRowNum === 0 ? field.RowFrom : startRowNum !== field.RowFrom ? startRowNum : field.RowFrom; 
        const startCol = startColNum > 0 ? startColNum : 1;

        if (totalNumberOfVines > 0)
            fillRowsCollection(startRow, startCol);
    }, [startRowNum, startColNum, totalNumberOfVines]); 

    useEffect(() => {

        if (plantInfos.length > 0) {
            setRowNumForView(plantInfos[0].Row);
        }

        if (rowsCollection.length > 0) {
            // get last station from rowsCollection (the new station for adding)
            const station = rowsCollection.find((station) => station.Occupied === false);
            // console.log('station >> ', station);
            if(station !== undefined) {
                setStartRowStr(startRowNum === 0 ? station.RowNum : startRowNum);
            }
        }
        
    },[rowsCollection]); 

    useEffect(() => {
        if (plantInfos.length > 0) {
            // console.log('must draw table on plantInfos changing >> ', plantInfos);
            DrawTable();
        }
    }, [plantInfos, occupiedLocations]); 


    useEffect(() => {
        if (selectedCultivar != null && selectedCultivar != undefined && selectedCultivar.Id != '00000000-0000-0000-0000-000000000000')
            setStationName(selectedCultivar.Name);
    },[selectedCultivar]);


    const onStationIdChange = (value) => {
        const values = [...plantInfos];
        for (var i = 0; i < values.length; i++) {
            values[i].StationId = value;
        }
        setPlantInfos(values);
    };

    
    const arrStationIdChange = (arr, value) => {
        if (arr === undefined || arr.length === 0)
            return;

        for (var i = 0; i < arr.length; i++) {
            arr[i].StationId = value;
        }
        return arr;
    };

    function updateLastSyncDate() {
        const values = [...plantInfos];
        for (var i = 0; i < values.length; i++) {
            values[i].LastSyncDate = correctTimeZone(new Date());
        }
        return values;
    };

    function arrUpdateLastSyncDate(arr) {
        if (arr === undefined || arr.length === 0)
            return;

        for (var i = 0; i < arr.length; i++) {
            arr[i].LastSyncDate = correctTimeZone(new Date());
        }
        return arr;
    };

    // const validateInput = () =>
    // {
    //     const errors = [];
 
    //     // Check if stationName is empty (undefined, null, or empty string)
    //     let found = !stationName; 
    //     // console.log('found >> ', found);
    //     if (found)
    //     {
    //         // If there are already errors, add a newline for separation
    //         if (errors.length > 0) errors.push("\n\n");
            
    //         // Add the error message
    //         errors.push("Station name can't be empty");
    //     }

    //     found = rootstock.Id === '00000000-0000-0000-0000-000000000000';
    //     if (found)
    //     {
    //         // console.log('found >> ', found);
    //         if(errors.length > 0)
    //             errors.push("\n\n");            
    //         errors.push("Unable to create station without Rootstock");
    //     }

    //     const isValid = isValidYearString(year, true);
    //     if (!isValid.res) {
    //         if(errors.length > 0)
    //             errors.push("\n\n");
    //         errors.push(isValid.msg);
    //     }
        
    //     return errors;
    // }

    const validateInput = () => {
        const errors = [];
    
        // Check if the station name is empty (undefined, null, or empty string)
        if (!stationName) {
            errors.push("Station name can't be empty");
        }
    
        // Check if the rootstock has the default invalid ID
        if (rootstock.Id === '00000000-0000-0000-0000-000000000000') {
            errors.push("Unable to create station without Rootstock");
        }
    
        // Validate the year and add the error if invalid
        const { res, msg } = isValidYearString(year, true);
        if (!res) {
            errors.push(msg);
        }
    
        // Return errors, joined with newline separators if multiple exist
        return errors.length > 0 ? errors.join("\n\n") : "";
    };

    
    // gets number of the current station and add new (next station) after current
    const createNewStation = (rowNum, startColNum, countOfColumns ) => {
        // Check if a field is selected, if not, return
        if (field.Id === '00000000-0000-0000-0000-000000000000') {
            return;
        }
    
        // Determine the number of columns to cover for the new station
        let columns = countOfColumns === undefined ? totalNumberOfVines : countOfColumns;  
        let values = [];  // To store the station data
    
        let defaultToCol = startColNum + columns - 1;  // Determine the last column the station should cover
        let remainingCols = columns;  // Keeps track of the columns left to assign
        let currentRow = rowNum;  // The current row we are processing
        let currentStartCol = startColNum;  // The current starting column in this row
    
        // Distribute the station across multiple rows if necessary
        while (remainingCols > 0) {
            // Calculate how many columns are available in the current row
            let availableColsInRow = field.VinesOnRow - currentStartCol + 1;
    
            // Determine the last column in the current row that the station will cover
            let toCol = (remainingCols > availableColsInRow) ? field.VinesOnRow : currentStartCol + remainingCols - 1;
    
            // Add the station segment for the current row
            values = values.concat({
                FieldNum: field.Id,  // The ID of the current field
                RowNum: currentRow,  // The row number where the station is placed
                StationNum: newStationNum,  // The station number
                FromCol: currentStartCol,  // Starting column in this row
                ToCol: toCol,  // Ending column in this row (could be the last column of the row or the last required column for the station)
                Selected: false,  // Station is not selected by default
                Occupied: false,  // Station is not occupied by default
            });
    
            // Update the remaining columns that still need to be assigned
            remainingCols -= (toCol - currentStartCol + 1);
    
            // Reset the start column to 1 for the next row
            currentStartCol = 1;
    
            // Move to the next row
            currentRow += 1;
        }
    
        // Return the array of values for the new station(s)
        return values;
    };  
    

    // The function creates an array of stations  
    // Function creates a new station to insert it into row, 
    // if other stations do not exist, the new station is inserted 
    // to the requested row and column (by comming parameters), 
    // Otherwise, it finds another segment of empty cells for the new station  
    const fillRowsCollection = (rowNum, fromCol) => {
        let newStation = getSegmentForNewStation(rowNum, fromCol);
        // console.log('newStation >> ', newStation); 
        setRowsCollection(newStation); 
    };

    // The function goes through the cells on the field and checks each one if the cell is empty 
    // if it is empty, function adds it to the new station otherwise moves to the next cell
    // returns a new station object
    const getSegmentForNewStation = (startRowNum, startFromCol) => {
        // console.log('In getEmptySegmentForNewStation !! ');
        let rowNum = startRowNum;
        let colNum = startFromCol;
        let maxRow = field.RowTo;
        let counter = 1;
        let newScionLocation = 1;
        let newStationStart = {
            statrtRow: rowNum,
            statrtCol: colNum
        };
        let scions = [];

        while (rowNum <= maxRow) {
            while (colNum <= field.VinesOnRow ) {
                let ocScion = getScionByRowCol(occupiedLocations, rowNum, colNum);
                if (ocScion === undefined || ocScion.FreeLocation === 'Yes') {
                    if (counter === 1) {
                        // If there is no existing station on this location, 
                        // create a new station
                        newStationStart.statrtRow = rowNum;
                        newStationStart.statrtCol = colNum;
                        newScionLocation = 1;
                    }

                    scions.push(
                        // excepted values: (id, row, col, stationId, occupied, uprooted, freeLocation, IsSeedling)
                        createScion(generateSyncId(), rowNum, colNum, 0, 2, 0, 'Yes', 0)
                    );

                    if (counter === totalNumberOfVines || (rowNum === maxRow && colNum === field.VinesOnRow)) {
                        //  add a new station to the requested segment  
                        // console.log('scions  >>  ', scions);
                        setPlantInfos(scions);
                        return createNewStation(newStationStart.statrtRow, newStationStart.statrtCol, newScionLocation);
                    }                                            
                    counter++;
                }
                else {
                    scions.push(
                        createScion(ocScion.Id, rowNum, colNum, ocScion.StationNum, 1, ocScion.IsUprooted, ocScion.FreeLocation, ocScion.IsSeedling));
                }

                newScionLocation++;
                colNum++;
            }
            rowNum++;
            colNum = 1;
        }
    };

    // This function not used because in the current version the station may not be a continuous sequence of empty cells 
    // replaced with getSegmentForNewStation function

    // searches for a continuous sequence of empty cells to add a new station.
    // if such sequence is found, it returns the previous station to add a new station after it
    const getEmptySegmentForNewStation = (startRowNum, startFromCol) => {
        // console.log('In getEmptySegmentForNewStation !! ');
        let rowNum = startRowNum;
        let colNum = startFromCol;
        let maxRow = field.RowTo;
        let counter = 1;
        let newStationStart = {
            statrtRow: rowNum,
            statrtCol: colNum
        };

        let prevStationNum = 0;
        let prevStationRowNum = rowNum;

        while (rowNum <= maxRow) {
            while (colNum <= field.VinesOnRow) {
                let ocScion = getScionByRowCol(occupiedLocations, rowNum, colNum);
                if (ocScion === undefined || ocScion.FreeLocation === 'Yes') {
                    if (counter === 1) {
                        // If there is no existing station on this location, 
                        // create a new station
                        newStationStart.statrtRow = rowNum;
                        newStationStart.statrtCol = colNum;
                    }
                    if (counter === totalNumberOfVines || colNum === field.VinesOnRow) {
                        // If an existing station is found, we need to add a new station after it
                        // otherwise add a new station to the requested segment
                        return getStationByRowStationNum(occupiedStations, prevStationRowNum, prevStationNum);
                    }                                            
                    counter++;
                }
                else {
                    counter = 1; 
                    prevStationNum = ocScion.StationNum;
                    prevStationRowNum = ocScion.ScionRow;
                }
                colNum++;
            }
            rowNum++;
            colNum = 1;
        }
        return getStationByRowStationNum(occupiedStations, prevStationRowNum, prevStationNum);
    };


    const getNextOccupiedStation = (row, col) => {
        // console.log('In getNextOccupiedStation !! ');
        let rowNum = row;
        let colNum = col;
        //console.log('In getNextOccupiedStation row = '+rowNum+' col =  '+colNum);

        let maxRow = field.RowTo;

        while (rowNum < maxRow) {
            while (colNum <= field.VinesOnRow) {
                let ocScion = getScionByRowCol(occupiedLocations, rowNum, colNum);
                if (ocScion !== undefined && ocScion.FreeLocation === 'No') {
                    return getStationByRowStationNum(occupiedStations, rowNum, ocScion.StationNum);
                }
                colNum++;
            }
            rowNum++;
            colNum = 1;
        }
    }; 

    // This function not used because in the current version the station may not be a continuous sequence of empty cells
    // gets number of the current station and add new (next station) after current
    const addNewStation = (currentStation) => {
        if (field.Id === '00000000-0000-0000-0000-000000000000') {
            return;
        }

        let values = [];

        // First add an existing station
        values = values.concat(currentStation);

        let defaultToCol = currentStation.ToCol + totalNumberOfVines;
        if (defaultToCol > field.VinesOnRow) {
            // adding the new station in two rows
            if (currentStation.ToCol+1 <= field.VinesOnRow)
                // adding the begining of a new station at the end of the first row
                values = values.concat({
                    FieldNum: currentStation.FieldNum,
                    RowNum: currentStation.RowNum,
                    StationNum: newStationNum,
                    FromCol: currentStation.ToCol+1,
                    ToCol: field.VinesOnRow,
                    Selected: false,
                    Occupied: false,
                });
            // if the row not last on the field, then add second part of stationto next row
            if (currentStation.RowNum + 1 <= field.RowTo)
                values = values.concat({
                    FieldNum: currentStation.FieldNum,
                    RowNum: currentStation.RowNum + 1,
                    StationNum: newStationNum,
                    FromCol: 1,
                    ToCol: defaultToCol-field.VinesOnRow,
                    Selected: false,
                    Occupied: false,              
                }); 
            else
                // not blank locations on row
                return values;
        }
        else {
            // add station on one row after existing
            values = values.concat({
                FieldNum: currentStation.FieldNum,
                RowNum: currentStation.RowNum,
                StationNum: newStationNum,
                FromCol: currentStation.ToCol + 1,
                ToCol: defaultToCol,
                Selected: false,
                Occupied: false,               
            });
        }   

        // console.log('In addNewStation values >> ', values);
        return values;
    };

    // gets number of the current station and add new row to it (to this station)
    const addScionsToNextRow = (currentStation) => {
        // console.log('currentStation >> ', currentStation);
        let values = [...rowsCollection];

        if (currentStation.RowNum < field.RowTo) {
            values = values.concat({
                FieldNum: currentStation.FieldNum,
                RowNum: currentStation.RowNum + 1,
                StationNum: currentStation.StationNum,
                FromCol: 1,
                ToCol: 1,
                Selected: false,
                Occupied: false,               
            });
        }   
        return values;
    };
    
    // gets number of the current station and add new row to it (first row to this station, current row will second)
    const addScionsToPrevRow = (currentStation) => {
        // console.log('currentStation >> ', currentStation);
        let values = [...rowsCollection];
        // remove last element from array
        let removed = values.pop();
        // get last element of the array without removing
        let prev = values.slice(-1).pop();

        //console.log('prev >> ', prev);
        if (prev !== undefined && prev.Occupied && prev.ToCol === field.VinesOnRow)
            return;      

        if (currentStation.RowNum > field.RowFrom) {
            values = values.concat({
                FieldNum: currentStation.FieldNum,
                RowNum: currentStation.RowNum - 1,
                StationNum: currentStation.StationNum,
                FromCol: field.VinesOnRow,
                ToCol: field.VinesOnRow,
                Selected: false,
                Occupied: false,              
            });
        }   

        removed.ToCol -= 1; 
        values = values.concat(removed);        
        return values;
    };

    const removePrevRow = (currentStation) => {
        let values = [...rowsCollection]; 
        values = values.filter(obj => (obj.StationNum !== currentStation.StationNum || obj.RowNum !== currentStation.RowNum));
        return values;
    };
    
        
    async function submit() {
        if (plantInfos.length === 0) 
        {
            setWarningMessage("List of scions is empty");
            setShowWarning(true);
            return;
        } 
        // console.log('plantInfos  ', plantInfos);
        
        const inputErr = validateInput();
        // Check if there are any errors
        if (inputErr) {  // inputErr will be "" if no errors
            setWarningMessage(inputErr);
            setShowWarning(true);
            return;
        }; 
   
        try {
            let cultivarId = null;
            let fromStationId = false;
            const rs = (rootstock.Id === '00000000-0000-0000-0000-000000000000') ? null : rootstock.Id
            // create station from seedling
            if (props.plantInfo != undefined && props.plantInfo != null) {
                const cultivar = {
                    Id: generateSyncId(),
                    CultivarName: stationName,
                    Brand: null,
                    Type: props.plantInfo.FruitColor,
                    // RootstockId:   fromStationId ? selectedCultivar.RootstockId : rs,
                    RootstockId: rs,  
                    CreateDate: correctTimeZone(new Date()),
                    CreatedBy: currentUser.email,
                    LastSyncDate: correctTimeZone(new Date()),
                };
                // console.log('cultivar before insert  ', cultivar);
                const response = await post("/insertCultivar", cultivar);

            
                // Check if the response is successful
                if (!response.success) {
                    throw new Error(`HTTP error! ${response.message}`);
                }
    
                cultivarId = response.result;
                // console.log('cultivarId  ' + cultivarId);
            }
            else {
                cultivarId = selectedCultivar.Id;

                 // 2 - create the station from another station
                fromStationId = selectedCultivar.ObjectType === 2;
            }

            // const rs = (rootstock.Id === '00000000-0000-0000-0000-000000000000') ? null : rootstock.Id;
            // console.log('plantInfo  ', props.plantInfo);
            if (cultivarId !== null && cultivarId !== undefined && cultivarId !== ""){
                const station = {
                    Id: generateSyncId(),
                    // StationName: (props.plantInfo !== undefined && props.plantInfo.IsSeedling === 1) ? stationName : selectedCultivar.Name,
                    StationName: stationName,
                    PrevStationId: fromStationId ? cultivarId : null,	
                    SeedlingId: (props.plantInfo !== undefined && props.plantInfo.IsSeedling === 1) ? props.plantInfo.Id : null,
                    CultivarId: fromStationId ? selectedCultivar.CultivarId : cultivarId,
                    RootstockId: rs,   
                    PlantingYear: year,
                    CreateDate: correctTimeZone(new Date()),
                    CreatedBy: currentUser.email,   
                    BestTreatmentId: null,
                    BestTreatmentDate: null,
                    BestTreatmentBy: null,
                    Comment: null,
                    LastSyncDate: correctTimeZone(new Date()),
                };                    

                // station.newStationNum = newStationNum;
                // temp.newStationName = stationName;
                // console.log('station  ', station);

                const response = await post("/createStation", station);
            
                // Check if the response is successful
                if (!response.success) {
                    throw new Error(`HTTP error! ${response.message}`);
                }
    
                const stationId = response.result;                
                // console.log('stationId  ' + stationId);

                if (stationId !== null && stationId !== undefined && stationId !== ""){
                    //onStationIdChange({ Id: stationId, Num: newStationNum});
                    // console.log('plantInfos  ', plantInfos);
                    const planned = plantInfos.filter(scion => scion.Occupied === 2);

                    // onStationIdChange(stationId);
                    arrStationIdChange(planned, stationId);
                    
                    // Update each item in the planned plants array:
                    // add the LastSyncDate property to each item
                    const updatedScions = arrUpdateLastSyncDate(planned);
                    // console.log('updatedScions  ', updatedScions);
                //    setPlantInfos(updatedScions);

                    const response = await post("/insertScions", updatedScions);
            
                    // Check if the response is successful
                    if (!response.success) {
                        throw new Error(`HTTP error! ${response.message}`);
                    }
        
                    const newScions = response.result;           

                    if (newScions !== null && newScions > 0) {
                        // not change this sequence !!!
                        if (props.setNewStationCreatedSuccessfully !== undefined)
                            props.setNewStationCreatedSuccessfully(true);

                            const newStation = {Id: stationId, Name: stationName};
                            // props.setSelectedStation({ Id: stationId, Name: stationName});

                            if (props.onCreateNewStation !== undefined)
                                await props.onCreateNewStation(newStation);

                        // props.setPostharvestButton({
                        //     sheetId: null,
                        //     sheetStatus: null,
                        //     sheetYear: null,
                        //     sheetColor: "status-unknown",
                        //     buttonLabel: "new postharvest"  
                        // });

                        props.setStationTreatments([{
                            StationId: stationId,
                            TreatmentID: null,
                            TreatmentName: "new treatment",
                            TreatmentStatus: null,
                            TreatmentYear: null,                                     
                        }]);                        
                    }

                    if (props.onClose !== undefined)
                        props.onClose();
                }
            }
        } 
        catch (error) {
            console.error(' 🔴 Error in submit >> ', error.message);

            // Construct error object
            const errorDetails = {
                error: error,
                parameters: JSON.stringify(plantInfos),
                userName: currentUser.email,
                moduleName: 'StationPopup',
                functionName: 'submit',
                description: `Error in submit for field ${JSON.stringify(plantInfos)}`
            };
            await DBlogError(errorDetails);
            return;
        }          
    }

    const close=()=>{
        navigate('/' );
    }    

    const DrawTable = () =>
    {
        if (plantInfos.length === 0)
            return;
        else     
            return (
                plantInfos.map((item) => 
                    DrawRow(item))
            );
    } 

    const onCheckedChange = (id, value) => {
        setPlantInfos((prevState) => {
          return prevState.map((el) =>
            el.Id === id ? { ...el, Checked: value } : el
          );
        });
    };

    // change row number in table  for a specific row
    const onRowChange = (id, value) => {
        if (value < 1)
        {
            setWarningMessage('Row number can\'t be smaller than 1 or empty');
            setShowWarning(true);
            return;
        }

        const found = plantInfos.find((el) => el.Id === id);

        // check if scion with same location already exist
        const index = plantInfos.findIndex((el) => el.Row === value && found.Column === el.Column);
        // console.log('index >> ', index);

        if (index === -1) { // scion is not found        
            setPlantInfos((prevState) => {
                return prevState.map((el) =>
                    el.Id === id ? { ...el, Row: value } : el
                );
            });
        }
        else
        {
            setWarningMessage('Scion with same row number and column number already exist');
            setShowWarning(true);
        }            
    };

    // change column number in table  for a specific row
    const onColumnChange = (id, value) => {
        if (value < 1)
        {
            setWarningMessage('Column number can\'t be smaller than 1 or empty');
            setShowWarning(true)
            return;
        }

        const found = plantInfos.find((el) => el.Id === id);
        
        // check if already exist
        const index = plantInfos.findIndex((el) => el.Column === value && found.Row === el.Row);
        // console.log('index >> ', index);
             
        if (index === -1) { // scion is not found          
            setPlantInfos((prevState) => {
                return prevState.map((el) =>
                    el.Id === id ? { ...el, Column: value } : el
                );
            });
        }
        else
        {
            setWarningMessage('Scion with same row number and column number already exist');
            setShowWarning(true);
        }      
    };

    // change the year value in the table for a specific row
    const onYearChange = (id, value) => {
        setPlantInfos((prevState) => {
            return prevState.map((el) =>
                el.Id === id ? { ...el, Year: value } : el
            );
        });
    };

    const onRootstChange = (id, rs) => {
       // console.log('option >> ', rs);
        const selected = ( rs === undefined) 
            ? {  
                Id: 0,
                Name: ''
            }
            : {  
                Id: rs.Id,
                Name: rs.Name
            }

        setPlantInfos((prevState) => {
            return prevState.map((el) =>
                el.Id === id ? { ...el, RootstockId: selected.Id, RootstockName: selected.Name } : el
            );
        });
    };    

    const onDeleteScion = (item) => {
         console.log('item >> ', item);
        // console.log('plantInfos >> ', plantInfos);

        const values = [...plantInfos];
        const index = values.findIndex((el) => el.Row === item.RowOnField && el.Column === item.ColOnField);
        // console.log('index >> ', index);

        if (index > -1) { // splice array when scion is found
            values.splice(index, 1); // 2nd parameter means remove one item only
        }
          
        // console.log(values);
        if (values.length === 0) {
            values.push(
                // excepted values: (id, row, col, stationId, occupied, uprooted, freeLocation, IsSeedling)
                createScion(generateSyncId(), item.RowOnField, item.ColOnField, 0, 2, 0, 'Yes', 0)              
            );
        }  
        updatePlantInfos(values);
        // setStartRowNum(values[0].Row);
        // setStartRowStr(values[0].Row);
        // setStartColNum(values[0].Column);
    };

    const onInsertScion = (item) => {
        // console.log('item >> ', item);
        // console.log('plantInfos >> ', plantInfos);

        const values = [...plantInfos];

        values.push(
            createScion(generateSyncId(), item.RowOnField, item.ColOnField, 0, 2, 0, 'Yes', 0)
        ); 
        updatePlantInfos(values);
        // setStartRowNum(values[0].Row);
        // setStartRowStr(values[0].Row);
        // setStartColNum(values[0].Column);
    };

    const shiftLeft = (item) => {
        const values = [...plantInfos];
        let occupiedCount = 0;

        // To insert an element at the start of an array 
        values.unshift(
            createScion(generateSyncId(), item.RowOnField, item.ColOnField, 0, 2, 0, 'Yes', 0)
        );

        do  {
            // To remove the last element from an array 
            values.pop();
            occupiedCount = values.filter(value => value.Occupied === 2).length;
        } while (occupiedCount > totalNumberOfVines)

        setPlantInfos(values);
        // setStartRowNum(values[0].Row);
        // setStartRowStr(values[0].Row);
        // setStartColNum(values[0].Column);
    };

    const shiftRight = (item) => {
        const values = [...plantInfos];
        let occupiedCount = 0;
        
        // To insert an element at the end of an array 
        values.push(
            createScion(generateSyncId(), item.RowOnField, item.ColOnField, 0, 2, 0, 'Yes', 0)
        );
       
    
        do  {
            // To remove the first element from an array
            values.shift(); 
            occupiedCount = values.filter(value => value.Occupied === 2).length;
        } while (occupiedCount > totalNumberOfVines)

        setPlantInfos(values);     
        // setStartRowNum(values[0].Row);
        // setStartRowStr(values[0].Row);
        // setStartColNum(values[0].Column);
    };
    

    // Function to sort locations by Row and Column
    const sortLocationsByRowCol = () => {
        let values = [...plantInfos];

        let sortedByRow = values.sort((a,b) => (a.Row > b.Row) ? 1 : ((b.Row > a.Row) ? -1 : 0))

        let maxRow = sortedByRow.slice(-1).pop().Row;
        values = [];

        let sorted = [];
        for (var i = 1; i <= maxRow; i++) {
                sorted = sortedByRow.filter(function (item){
                    return item.Row === i;
                });
            sorted = sorted.sort((a,b) => (a.Column > b.Column) ? 1 : ((b.Column > a.Column) ? -1 : 0));
            values = values.concat(sorted);
        }
        return values;
    };

    // Function to sort locations by Row and Column
    const sortArrayByRowCol_1 = (array) => {
        let sortedByRow = array.sort((a,b) => (a.Row > b.Row) ? 1 : ((b.Row > a.Row) ? -1 : 0))

        let maxRow = sortedByRow.slice(-1).pop().Row;
        array = [];

        let sorted = [];
        for (var i = 1; i <= maxRow; i++) {
                sorted = sortedByRow.filter(function (item){
                    return item.Row === i;
                });
            sorted = sorted.sort((a,b) => (a.Column > b.Column) ? 1 : ((b.Column > a.Column) ? -1 : 0));
            array = array.concat(sorted);
        }
        return array;
    };

    // Function to sort locations by Row and Column
    const sortArrayByRowCol = (array) => {
        const sortedArray = [...array];
        sortedArray.sort((a, b) => {
            // First, sort by Row
            if (a.Row !== b.Row) {
                return a.Row - b.Row;
            }
            // If Rows are equal, sort by Column
            return a.Column - b.Column;
        });
        return sortedArray;
    };

    // Function to update plantInfos state
    const updatePlantInfos = (newArray) => {
        // Check if the array is not empty
        if (newArray.length > 0) {
            // Sort the array
            const sortedArray = sortArrayByRowCol(newArray);
            // Update the state with the sorted array
            setPlantInfos(sortedArray);
        } else {
            // If the array is empty, update the state directly
            setPlantInfos(newArray);
        }
    };

    
    const sortPlantInfosByRowCol = () => {
        setPlantInfos(sortLocationsByRowCol());
    }   

    const addScionToTable = () => {
        const scions = sortLocationsByRowCol();
        let lastScionOnStation = scions.slice(-1).pop();
        // let maxRow = scions.slice(-1).pop().Row;   
        // let lastCol = scions.slice(-1).pop().Column;
        
        let maxCol = 1;
        scions.map( (el) => {
            maxCol = (el.Column > maxCol ?   el.Column :  maxCol);
        }); 
        // console.log('maxCol >> ',maxCol); 

        let maxId = 1;
        scions.map( (el) => {
            maxId = (el.Id > maxId ?   el.Id :  maxId);
        });         
        
        let values = [...plantInfos];
        if(lastScionOnStation.Column < maxCol)
            {
                let col = lastScionOnStation.Column;
                values.push(
                    createScion(++maxId, lastScionOnStation.Row, ++col, false, 'No')
                )
            }        
            else { 
                let row = lastScionOnStation.Row;
                values.push(
                    createScion(++maxId, ++row, false, 'Yes')
                )
            }
        
        setPlantInfos(values);            
        // console.log('scions >> ',scions); 
        // console.log('plantInfos >> ',plantInfos); 

    }

    const onAllCheckedChange = (value) =>
    {
        //console.log(value);
        setCheckAll(value)
        setPlantInfos((prevState) => {           
            return prevState.map((el) =>
                ({ ...el, Checked: value})
            );   
        });     
    }
   
    const onRootstChangeSelected = (evaluation) =>
    {
        // console.log('evaluation >> ', evaluation);
        const rootst = evaluation === undefined 
            ? {  
                Id: '00000000-0000-0000-0000-000000000000',
                Name:'',
            }
           : evaluation;
        
        setRootstock(rootst);
        // setPlantInfos((prevState) => {
        //     return prevState.map((el) =>
        //         el.Checked === true ? { ...el, RootstockId: rootst.Id,  RootstockName: rootst.Name} : el
        //     );
        // });
    }     
       
    const onYearChangeSelected = (value) => {
        setYear(Number(value));
        
        if (value.length === 4)
        {
            setPlantInfos((prevState) => {
                return prevState.map((el) =>
                    el.Checked === true ? { ...el, Year: value } : el
                );
            });
        }
    };    

    const onChangeSelectedField = async  (fieldOption) => {
        // console.log('In onChangeSelectedField >> ');
        setCheckAll(false);
        let field;
        setFieldName('');
        setPlantInfos([]);
        setOccupiedLocations([]);
        setRowsCollection([]);

        if (fieldOption !== undefined) {
            field = fieldOption;
            setFieldName(field.Description);
            await loadExistedStationsFromDB(field.Id);
        } 
        else {
            field = 
            {  
                Id: '00000000-0000-0000-0000-000000000000',
                RowFrom: 0,
                RowTo: 0,
                FieldName:'',
                FieldType: 0,
                VinesOnRow: 0,
                Description: "",
            };
        }
        // console.log('field >> ', field);
        setField(field);
        setStartRowNum(field.RowFrom);
        setStartRowStr(field.RowFrom);
        setStartColNum(0);    
    };

    useEffect(() => {
        // console.log('In useEffect on field >> ', field.Id);
        if (field.Id !== '00000000-0000-0000-0000-000000000000') {
            fillRowsCollection(field.RowFrom, 1);
        }
    }, [field]);

    const closeWarning = () => {
        setShowWarning(false);
        setWarningMessage('');
    }

    const DrawAllStations = () =>
    {
        // console.log('In DrawAllStations rowsCollection >> ', rowsCollection);
        return (
            rowsCollection.map(item => 
                DrawStation(item))
        );
    } 

    // const onClosStationsField = () => { 
    //     setOpenStationsField(false);
    // };

    const onOpenParentsListWindow = () => {
        setOpenParentsListWindow(true);
    }

    const onCloseParentsListWindow = () => { 
        setOpenParentsListWindow(false);
    };

    const handleKeyDown = (event) => {
        // Allow arrow keys (37: left, 38: up, 39: right, 40: down)
        if (![37, 38, 39, 40].includes(event.keyCode)) {
          event.preventDefault();
        }
    };

    // Function to create a new cultivar
    const createNewCultivar = () => {
        const cultivar = {
            // Id: generateSyncId(),
            CultivarID: null,
            CultivarName: '',
            Brand: '',
            Mother: '',
            Father: '',
            RootstockId: null,
            Type: null,
            Harvest: null,
            BudBreak: null,
            RainResistance: null,
            Chilling: null,
            CreateDate: null,
            CreatedBy: null,
            IsCommercial: 1,
            CommercialFromDate: null,
            SetAsCommercialBy: null,
            AddDate: null,
            AddedBy: '',
            Country: '',
            Company:'',
            Notes: '',
            LastSyncDate: null
        };
            
        // Set the selected cultivar in state
        setNewCultivar(cultivar);
    
        // Show the cultivar details
        setShowCultivarDetails(true);
    };

        
    const DrawStation = (station) => {
        // console.log('station  >>  ', station);
        let style = {padding: "0 5px"};

        let stationNameStyle = { ...style };
        if (!station.Occupied && props.plantInfo != undefined) {
            stationNameStyle = { ...stationNameStyle, background: "white" };
        }

        // if (!station.Occupied || station.FreeLocation === 'Yes')
        //     style.background = "white";   
        
        let rowVineStyle = { ...style };
        if (!station.Occupied || station.FreeLocation === 'Yes') {
            rowVineStyle = { ...rowVineStyle, background: "white" };
        }

        return (
            <Box id="create-station" flex={false} key={station.RowNum} direction="row" justify="between" align="end" style={{ width: '95%', height: 'auto' }} > 
                {/* <Box pad={{ vertical: "xxsmall" }} width="10px">
                 </Box>                                              */}
                <Box pad={{ vertical: "xxsmall" }} width="200px" direction="row" >
                    <Text style={{whiteSpace: "nowrap"}}>Station: &nbsp;</Text>
                    <TextInput
                       // type="number"
                        value={(station.Occupied) ? station.StationName : stationName}
                        style={stationNameStyle}
                        onChange={(event) => {
                            setStationName(event.target.value !== undefined && event.target.value !== "" ? event.target.value.substring(0, 25) : "")
                            // onChangeStationNum(event.target.value, station.RowNum, station.StationNum)
                        }}                        
                        readOnly = {station.Occupied || props.plantInfo === undefined}
                    />
                </Box>   
                <Box pad={{ vertical: "xxsmall" }} width="120px" direction="row" >
                    <Text style={{whiteSpace: "nowrap"}}>Row: &nbsp;</Text>
                    <TextInput
                        type="number"
                        value={station.RowNum}
                        style={{ padding: "0 5px"}} 
                        readOnly
                    />
                </Box>                                             
                <Box pad={{ vertical: "xxsmall" }} width="150px" direction="row" >
                    <Text style={{whiteSpace: "nowrap"}}>From vine: &nbsp;</Text>
                    <TextInput
                        width="50px"
                        type="number"
                        value={station.FromCol}
                        // style={rowVineStyle} 
                        style={{ padding: "0 5px"}} 
                        onChange={(event) => {
                           onChangeStationFromCol(event.target.value, station.RowNum, station.StationNum);
                        }}
                        onKeyDown = {handleKeyDown}
                        // readOnly = {station.Occupied || station.FreeLocation === 'No'}
                        readOnly
                    />
                </Box>
                <Box pad={{ vertical: "xxsmall" }} width="130px" direction="row">
                    <Text style={{whiteSpace: "nowrap"}}>To vine: &nbsp;</Text>
                    <TextInput
                        type="number"                        
                        value={station.ToCol}
                        // style={rowVineStyle} 
                        style={{ padding: "0 5px"}} 
                        onChange={(event) => {
                            onChangeStationToCol(event.target.value, station.RowNum, station.StationNum);
                        }}
                        onKeyDown = {handleKeyDown}
                        // readOnly = {station.Occupied || station.FreeLocation === 'No'}
                        readOnly
                    />
                </Box>                      
            </Box>     


        );
    }

    const DrawRow = (scion) =>
    {
        // console.log('scion >> ',scion);     
        return(
            <Box  key={scion.Id} direction="row" align="center" background="light-3" justify="between" style={{minHeight: '30px' }}>

                <Box  width="18%" >
                    <TextInput
                        type="number"                        
                        value={scion.Row}
                        style={{ padding: "1px 0 1px 10px"}} 
                        onChange={(event) => 
                            onRowChange(scion.Id, Number(event.target.value))
                        }
                        readOnly
                    /> 
                </Box>   
                <Box   width="18%" >
                    <TextInput
                        type="number"                        
                        value={scion.Column}
                        style={{ padding: "1px 0 1px 10px"}} 
                        onChange={(event) => 
                            onColumnChange(scion.Id, Number(event.target.value))
                        }
                        
                        readOnly
                    /> 
                </Box>  
                <Box   
                    width="28px" height="28px" align="start" 
                    hoverIndicator
                    onClick={(event) => {
                        onDeleteScion(scion.Id);
                    }}
                >
                    <Trash color="red" />
                </Box>                                                                 
            </Box>
        );
    } 




    let title = props.plantInfo === undefined ? "NEW STATION" : " Station for  " + (props.plantInfo.IsSeedling === 1 ? 'Seedling' : 'Scion');

    const style = {
        border: "2px solid",       
        margin: "10px",
    };

    // console.log('plantInfos >> ',plantInfos);
    //console.log('plantInfo >> ', props.plantInfo);
    // console.log('selectedCultivar >> ', selectedCultivar);
    
    // const textColor = field.Id === '00000000-0000-0000-0000-000000000000' ? "red" : "brand";
    
    return (   
        <Layer
            id="create-station"
            position="center"
            onEsc={props.onClose}
        >
            {loading && (
            <Box align="center" direction="row" gap="small" pad="small">
                <Spinner /> <Text>Loading...</Text>
            </Box>
            )}

            {showWarning && (
                <WarningPopupWindow msg={warningMessage} close={closeWarning}/>
            )}
            <Box width="large" style={style}  pad="small"  background="light-3" >
                <Header margin="none" background="light-4" pad="small" height="xxsmall" justify="around">
                    <Text alignSelf="start" color="brand" size="large"  align="center" >
                        <strong>{props.plantInfo === undefined ? 'NEW STATION' : 'Station for ' + ( props.plantInfo.IsSeedling === 1 ? 'Seedling' : 'Scion')}  {props.plantInfo === undefined ? '' : props.plantInfo.SUID}</strong>
                    </Text>
                </Header>

                <Box style={{ padding: "10px 10px 0 10px"}} >
                    
                    <Box  direction="row-responsive" pad={{ vertical: "xxsmall" }} justify="between" align="center">
                        <Box direction="row-responsive" align="baseline">
                        <Box >
                            <Text weight="bold"> Enter station name: &nbsp;</Text>
                        </Box>

                        {/* creating station from seedling and name for station is seedling SUID */}
                        { props.plantInfo != undefined && props.plantInfo != null ?
                        <Box margin={{ vertical: "xsmall" }} background='light-1'  width="300px" >
                            <TextInput
                                value={stationName}
                                style={{ padding: "0 5px"}} 
                                onChange={event => setStationName(event.target.value !== undefined && event.target.value !== "" ? event.target.value.substring(0, 25) : "")}
                            />
                        </Box>
                        :      
                        // creating station from cultivar and name for station is name of cultivar                  
                        <Box   width="250px">
                            <Box  direction="row"  border
                                onClick={()=> { 
                                    onOpenParentsListWindow();
                                }} >
                                <TextInput
                                    hoverIndicator
                                    focusIndicator={false}
                                    placeholder="Select station name..."
                                    name="stationName"
                                    size="medium"   
                                    style={{ padding: "3px 0 3px 10px"}}            
                                    value={selectedCultivar.Name}
                                    plain
                                />
                                <Search style={{ margin:"5px"}}  color="brand" 
                                    // hoverIndicator 
                                />                                
                            </Box> 
                       
                        </Box> 
                        }
                        </Box>
                        
                        <Box>
                            <Button label="Add new Cultivar" 
                            onClick={createNewCultivar}
                            style={{width: "200px"}} />    
                        </Box>
                    </Box>                      
                    
                    {openParentsListWindow && 
                    <ParentsListWindow 
                        parentsList={props.parentsList} 
                        searchValue={''}
                        onClose={onCloseParentsListWindow}   
                        changeParent={changeSelectedCultivar} 
                        prevParent={selectedCultivar}
                        >
                    </ParentsListWindow>}
                                        
                    <Box pad={{ vertical: "xxsmall" }}  direction="row-responsive" justify="between" >
                        <Box   direction="row-responsive" width={size === 'small' ? '85%' : '50%'} >
                            <Box pad={{ vertical: "small" }} width="90px" >
                                <Text>Location:</Text>
                            </Box>
                            <Box pad={{ vertical: "small" }} width="250px" >
                                <Select
                                    value={field.FieldName}
                                    valueKey={{key: 'FieldName', reduce: true }}
                                    labelKey='FieldName'
                                    placeholder="Select location..."                                    
                                    style={{padding: "1px 0 1px 10px", margin: "0 4%"}} 
                                    // options={fieldList.filter(item => item.FieldType === 2)}   
                                    options={fieldList}  
                                    onChange={({option}) => onChangeSelectedField(option)}
                                    clear                                  
                                />
                            </Box>
                        </Box>
                        <Box pad={{ vertical: "small" }}  width={size === 'small' ? '90%' : '40%'} >
                            <Text weight="bold" color="brand"> {fieldName} </Text> 
                        </Box>

                    </Box>

                    {field.Id !== '00000000-0000-0000-0000-000000000000' && 
                    <Box pad={{ vertical: "xxsmall" }}  direction="row-responsive" justify="between" align="center" >
                        <Text weight="bold" margin={{vertical: "small"}}>Change location to:</Text>
                        <Box pad={{ vertical: "xxsmall" }} width="120px" direction="row" >
                            <Text style={{whiteSpace: "nowrap"}}>Row: &nbsp;</Text>
                            <TextInput
                                type="number"
                                value={startRowStr === '0' ? "" : startRowStr}
                                style={{ padding: "0 5px", background: "white"}}
                                onChange={(event) => {
                                    onChangeStartRow(event.target.value);
                                }}                        
                            />
                        </Box>                                             
                        <Box pad={{ vertical: "xxsmall" }} width="150px" direction="row" >
                            <Text style={{whiteSpace: "nowrap"}}>From vine: &nbsp;</Text>
                            <TextInput
                                width="50px"
                                type="number"
                                value={startColNum === 0 ? "" : startColNum}
                                style={{ padding: "0 5px", background: "white"}}
                                onChange={(event) => {
                                    onChangeStartCol(event.target.value);
                                }}
                            />
                        </Box>
                        <Box pad={{ vertical: "xxsmall" }} width="150px" direction="row" >
                            <Text style={{whiteSpace: "nowrap"}}>Total vines: &nbsp;</Text>
                            <TextInput
                                width="50px"
                                type="number"
                                value={totalNumberOfVines === 0 ? "" : totalNumberOfVines}
                                style={{ padding: "0 5px", background: "white"}}
                                onChange={(event) => {
                                    onChangeTotalNumberOfVines(event.target.value);
                                }}
                            />
                        </Box>
                        <Box  pad={{ vertical: "small" }} direction="row" width="40px" justify="between">
                            {/* <Box  hoverIndicator >
                                <View color="brand" onClick={() => setOpenStationsField(true)} />
                            </Box> */}
                        </Box>

                    </Box>
                    }

                    <Box background="neutral-3" height="2px" margin={{vertical: "small"}}> </Box>

                    {(rowsCollection.length !== 0) &&
                    <>
                    <Box  flex={false}  overflow='auto' >
                        <Box flex={true} align='center' style={{height: '600px' ,  maxHeight: '600px', width: "718px" , maxWidth: "718px" }} 
                        >
                            {DrawAllStations()} 
                        </Box>
                    </Box>
                    <Box background="neutral-3" height="2px" margin={{vertical: "small"}}> </Box>
                    </>
                    }
                    

                    {/* <Text weight="bold" >Update all selected scions:</Text> */}

                    <Box  direction="row-responsive" justify="around" style={{ padding: "10px 0 0 0" }} align="baseline">
                        <Box direction="row">
                            <Text>Rootstock: &nbsp;</Text>
                            {/* { props.plantInfo != undefined && props.plantInfo != null 
                            ? */}
                               
                                <Select
                                    value={rootstock.Name}
                                    valueKey={{key: "Name", reduce: true }}
                                    labelKey="Name"
                                    placeholder="Select Rootstock..."
                                    style={{padding: "1px 0 1px 10px", margin: "0 4%"}} 
                                    options={rootstockList}            
                                    onChange={({option}) => onRootstChangeSelected(option)}                         
                                    emptySearchMessage={"No Rootstock Available"} 
                                    clear                                  
                                />
                            {/* :
                            <Text border>&nbsp;<span style={{whiteSpace: 'pre-line'}}><strong><em>{rootstock.Name}</em></strong></span></Text>                   
                            } */}
                        </Box>  

                        <Box direction="row"  width="120px" >
                            <Text>Year: &nbsp; &nbsp; &nbsp;</Text>
                            <TextInput
                                type="number"                        
                                value={year}
                                style={{padding: "0 5px"}} 
                                
                                onChange={(event) => {
                                    onYearChangeSelected(event.target.value);
                                }}
                            />
                        </Box>                             
                    </Box> 
                </Box>

                {/* start table */}
                {(plantInfos.length > 0) ?   
                 <Box  flex={false}  overflow='auto' > 
                    <StationsField occupiedLocations={occupiedLocations} 
                        rowNum={rowNumForView} totalNumberOfVines={totalNumberOfVines} newPlants={plantInfos} field={field} 
                        rowsCollection={rowsCollection} updateRowsCollectionState={updateRowsCollectionState} 
                        onChangeStationToCol={onChangeStationToCol} onChangeStationFromCol={onChangeStationFromCol}
                        newStationNum={newStationNum} stationName={stationName}
                        onDeleteScion={onDeleteScion} onInsertScion={onInsertScion} 
                        shiftLeft={shiftLeft} shiftRight={shiftRight}
                    />

                </Box> 
                : 
                <Box width='96%' alignSelf="center" margin="small" pad="small" height="480px" border>
                    <Image
                        alignSelf="center"
                        src="Grape.png" 
                        fit="cover"   
                        opacity="medium"                          
                    />
                </Box>
                }                
                {/* end table */}

                <Box align="center" direction="row-responsive" gap="small" pad="small" style={{margin:"0 auto"}}>
                    <Button label="Create station" onClick={submit} style={{width: "200px"}} />
                    <Button primary style={{color: "#ffffff",  width: "200px"}} label="Cancel" onClick={props.onClose} />
                </Box>


           {/* Show CultivarDetails Modal */}
           {showCultivarDetails && 
                <Layer
                id="alertmsg"
                position="center"
                modal
                style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dim background for modal effect
                }}
            >
                <Box 
                    overflow='auto'
                    pad="small" 
                    gap="small" 
                    width="large"  
                    background="light-3"  
                    border={{ color: "brand"}}
                    style={{
                        position: 'relative',
                        margin: 'auto', // Center horizontally and vertically
                    }}
                >            
                    <CultivarDetails
                        cultivar={newCultivar} // Pass the cultivar to CultivarDetails 
                        onClosePopup={() => setShowCultivarDetails(false)} 
                        createFromStation={false}
                        loadCultivarsList={props.loadParents}
                        />
                    </Box>   
                </Layer>                        
            } 




            </Box>
        </Layer>
    );
  };
  
  export default StationPopup;
  